import React from "react";
import { Routes, Route } from "react-router-dom";
import DikshaPage from "../screens/DikshaPage";

const DikshaRoutes: React.FC = () => (
  <Routes>
    <Route path="/" element={<DikshaPage />} />
  </Routes>
);

export default DikshaRoutes;
